import useAllFilterStore from '../shared/hooks/allFilterStore';
import { FrontendFilterValue, SelectedFilters } from '../types/filters.type';
import { chipBackgroundColour, concatRangeValues, isRangeFilter } from '../utils/filters';
import Chip from './chip';

export default function FilterSummary({ filters, onClick }:
{ filters: SelectedFilters, onClick?: (category: string, key: string, filterDisplayName: string, value: FrontendFilterValue) => void }) {
  const { filterTypeLookup } = useAllFilterStore();

  return (
    <div className="flex flex-col mx-4 justify-start items-start">
      <div className="flex flex-col border rounded w-full p-2">
        {Object.entries(filters).flatMap(([category, filter]) => Object.entries(filter).map(([key, values]) => {
          const { displayName, selectedValues } = values;
          const isRange = isRangeFilter(key, filterTypeLookup);
          const concatedSelectedValues = concatRangeValues(selectedValues, isRange);
          const filterDisplayName = `${displayName}:`;
          return (
            <div key={`${category}-${key}`} className="flex flex-wrap items-center gap-1">
              <span className="font-thin text-start">
                {filterDisplayName}
              </span>
              {Array.isArray(concatedSelectedValues)
                  && concatedSelectedValues.map((value) => (
                    <Chip
                      closeButton={onClick !== undefined}
                      onClick={onClick ? () => onClick(category, key, displayName, value) : undefined}
                      key={`${key}-${value.id}`}
                      text={value.displayName}
                      colour={chipBackgroundColour[key]}
                      small
                    />
                  ))}
            </div>
          );
        }))}
      </div>
    </div>
  );
}
